import React from 'react';
import { gql } from '@apollo/client';
import { Datagrid } from 'react-admin';
import IdField from 'components/IdField';
import List from 'components/List';

const AssignmentLocationsList = () => (
  <List exporter={false}>
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <IdField />
    </Datagrid>
  </List>
);

AssignmentLocationsList.query = gql`
  query GET_LIST($input: AssignmentLocationQueryInput) {
    _assignmentLocationsMeta(input: $input) {
      count
    }
    assignmentLocations(input: $input) {
      id
      location_id
      location {
        id
        name
        status
        location_type {
          id
          label
        }
        phone_number
        account_manager_id
        account_manager {
          id
          account {
            id
            name
          }
        }
        sales_associate_id
        sales_associate {
          id
          account {
            id
            name
          }
        }
      }
      primary_location
    }
  }
`;

export default AssignmentLocationsList;
